import type { ParentType } from '@risksmart-app/domain/src/types/consts/parent-type';
import { ParentTypes } from '@risksmart-app/domain/src/types/consts/parent-type';

export interface NavigationVisibilityResponseRow {
  parentType: ParentType;
  visible: boolean;
}

/**
 * Maps a parent type to the parent type whose root permission grant determines
 * navigation visibility for it. The permission service uses this to collapse
 * fine-grained child types onto their navigation root before checking access.
 */
export const NAVIGATION_PARENT_TYPES: Partial<Record<ParentType, ParentType>> =
  {
    [ParentTypes.InternalAuditEntity]: ParentTypes.InternalAuditEntity,
    [ParentTypes.InternalAuditReport]: ParentTypes.InternalAuditReport,
    [ParentTypes.Risk]: ParentTypes.Risk,
    [ParentTypes.Appetite]: ParentTypes.Appetite,
    [ParentTypes.Acceptance]: ParentTypes.Acceptance,
    [ParentTypes.Document]: ParentTypes.Document,
    [ParentTypes.Obligation]: ParentTypes.Obligation,
    [ParentTypes.ComplianceMonitoringAssessment]:
      ParentTypes.ComplianceMonitoringAssessment,
    [ParentTypes.ThirdParty]: ParentTypes.ThirdParty,
    [ParentTypes.Issue]: ParentTypes.Issue,
    [ParentTypes.IssueRiskEvent]: ParentTypes.Issue,
    [ParentTypes.IssueBreachLog]: ParentTypes.Issue,
    [ParentTypes.IssueGdprBreachLog]: ParentTypes.Issue,
    [ParentTypes.IssuePciBreachLog]: ParentTypes.Issue,
    [ParentTypes.IssueSarLog]: ParentTypes.Issue,
    [ParentTypes.IssueConsumerDuty]: ParentTypes.Issue,
    [ParentTypes.IssueCustomerTrust]: ParentTypes.Issue,
    [ParentTypes.Indicator]: ParentTypes.Indicator,
    [ParentTypes.Assessment]: ParentTypes.Assessment,
    [ParentTypes.EnterpriseRisk]: ParentTypes.Risk,
    [ParentTypes.Control]: ParentTypes.Control,
    [ParentTypes.Action]: ParentTypes.Action,
    [ParentTypes.Asset]: ParentTypes.Asset,
    [ParentTypes.ControlGroup]: ParentTypes.ControlGroup,
    [ParentTypes.AttestationRecord]: ParentTypes.Document,
    [ParentTypes.RiskControlledInternalAuditResult]:
      ParentTypes.InternalAuditEntity,
    [ParentTypes.RiskUncontrolledInternalAuditResult]:
      ParentTypes.InternalAuditEntity,
    [ParentTypes.DocumentInternalAuditResult]: ParentTypes.InternalAuditEntity,
    [ParentTypes.ObligationInternalAuditResult]:
      ParentTypes.InternalAuditEntity,
    [ParentTypes.UncontrolledRiskAssessmentResult]: ParentTypes.Assessment,
    [ParentTypes.QuestionnaireTemplate]: ParentTypes.QuestionnaireTemplate,
    [ParentTypes.ThirdPartyResponse]: ParentTypes.ThirdPartyResponse,
    [ParentTypes.TestResult]: ParentTypes.TestResult,
    [ParentTypes.Cause]: ParentTypes.Cause,
    [ParentTypes.Consequence]: ParentTypes.Consequence,
    [ParentTypes.AssessmentActivity]: ParentTypes.Assessment,
    [ParentTypes.RiskAssessmentResult]: ParentTypes.Assessment,
    [ParentTypes.DocumentAssessmentResult]: ParentTypes.Assessment,
    [ParentTypes.ObligationAssessmentResult]: ParentTypes.Assessment,
    [ParentTypes.CustomDatasource]: ParentTypes.CustomDatasource,
    [ParentTypes.Impact]: ParentTypes.Impact,
    [ParentTypes.ImpactRating]: ParentTypes.ImpactRating,
    [ParentTypes.ObligationChange]: ParentTypes.ObligationChange,
  };
